"use strict";

import React from 'react';
import SaveCancelButtons from "../../component/SaveCancelButtons";
import Icon from "../../component/Icon";
import AccountEmailForm from "./AccountEmailForm";

const AccountEmailFormBundle = ({email='', emailLegend='Email', emailIsUnique=()=>{}, saveText='Save',
    onSubmit=()=>{}, onCancel=()=>{},}) => {
    return (
        <AccountEmailForm email={email} emailLegend={emailLegend} emailIsUnique={emailIsUnique} onSubmit={onSubmit} onCancel={onCancel}>
            <SaveCancelButtons wrapperStyle={{paddingTop: 0,}}
                               saveText={saveText}
                               saveButtonType="submit"
                               saveContent={<Icon name="right" className="icon--collapse-right" />}
                               saveClassName=" has-icon-right"  />
        </AccountEmailForm>
    );
};

export default AccountEmailFormBundle;
